import { algoliaIndex } from '@/lib/algolia'
import { isNonEmptyArray, isNonEmptyString } from '../checks'
import { PopularTreatmentItem } from '@/types/models'
export const searchForFacetValues = async ({
  parentLocation,
  location,
  locationSlug,
  terms
}: {
  location: string
  parentLocation?: string
  locationSlug?: string
  terms: PopularTreatmentItem[]
}): Promise<{ label; count }[] | []> => {
  if (!isNonEmptyArray(terms)) {
    return []
  }

  const queries = terms.map((term) => {
    const termId = term.slug.replaceAll('/', '')
    const locationQuery: string[] = []
    if (isNonEmptyString(location)) {
      locationQuery.push(`locations:"${location}"`)
    }
    if (isNonEmptyString(parentLocation)) {
      locationQuery.push(`locations:"${parentLocation}"`)
    }

    const locationFilters = locationQuery.filter(Boolean).join(' AND ')

    return fetch(
      `/api/facet/count?term=${termId}&taxonomy=${term.attribute}&location=${locationSlug}`
    )
      .then((r) => r.json())
      .then((response) => ({
        facetHits: [
          {
            value: term.label,
            highlighted: `<em>${term.label}</em>`,
            count: response.data.count
          }
        ],
        exhaustiveFacetsCount: false,
        processingTimeMS: 1
      }))
      .catch((e) => {
        return []
      })
  })

  const results = await Promise.all(queries)
  const cardData = results.reduce((acc, result, index) => {
    const matchedResult = result?.facetHits?.find(
      (hit) => hit.value === terms[index].label
    )
    if (!matchedResult) {
      return acc
    }

    return { ...acc, [matchedResult?.value]: matchedResult?.count }
  }, {})
  return cardData
}
